import React from 'react';

const ShortcutHelpModal = ({ open, sections = [], onClose, pageHref = '' }) => {
  if (!open) return null;

  return (
    <div
      className="frontoffice-shortcuts-backdrop"
      role="presentation"
      onClick={(event) => {
        if (event.target === event.currentTarget && onClose) {
          onClose();
        }
      }}
    >
      <div
        className="frontoffice-shortcuts-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="frontoffice-shortcuts-title"
      >
        <div className="frontoffice-shortcuts-header">
          <div>
            <div className="frontoffice-shortcuts-eyebrow">Keyboard Help</div>
            <h2 id="frontoffice-shortcuts-title" className="frontoffice-shortcuts-title">
              Front Office Shortcuts
            </h2>
            <p className="frontoffice-shortcuts-subtitle mb-0">
              Use these shortcuts to move faster during live call handling. Only deliberate shortcut combos are captured, so normal typing still works.
            </p>
          </div>
          <button
            type="button"
            className="btn-close"
            aria-label="Close keyboard shortcuts help"
            onClick={onClose}
          ></button>
        </div>

        <div className="frontoffice-shortcuts-body">
          {sections.map((section) => (
            <section key={section.title} className="frontoffice-shortcuts-section">
              <div className="frontoffice-shortcuts-section-header">
                <h3 className="frontoffice-shortcuts-section-title">{section.title}</h3>
                {section.description ? (
                  <p className="frontoffice-shortcuts-section-copy mb-0">{section.description}</p>
                ) : null}
              </div>

              <div className="frontoffice-shortcuts-list">
                {section.items.map((item) => (
                  <div key={item.id} className="frontoffice-shortcuts-item">
                    <div className="frontoffice-shortcuts-item-copy">
                      <div className="frontoffice-shortcuts-item-title">{item.title}</div>
                      <div className="frontoffice-shortcuts-item-description">{item.description}</div>
                    </div>
                    <div className="frontoffice-shortcuts-keys" aria-label={`Shortcut ${item.combo}`}>
                      {String(item.combo || '')
                        .split(' / ')
                        .map((variant) => (
                          <div key={variant} className="frontoffice-shortcuts-keyset">
                            {variant.split('+').map((part) => (
                              <kbd key={part} className="frontoffice-shortcuts-kbd">
                                {part}
                              </kbd>
                            ))}
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="frontoffice-shortcuts-footer">
          <div className="frontoffice-shortcuts-footer-copy">
            Press <kbd className="frontoffice-shortcuts-kbd">Esc</kbd> to close this guide quickly.
          </div>
          {pageHref ? (
            <a
              href={pageHref}
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline-primary btn-sm"
            >
              Open Full Page
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ShortcutHelpModal;
